<template>
    <div class="text-center">
      <v-dialog v-model="dialog" width="500">
        <v-card> 
          <v-card-text class="pt-2"> 
            <InsRestDocus ref="refDocus"/>
            <v-progress-linear indeterminate v-if="loading" />
            <p class="text-center red--text"> {{ msg }} </p>
          </v-card-text>
  
          <v-divider></v-divider>
  
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" :disabled="loading" text @click="dialog = false"> cancelar </v-btn>
            <v-btn color="primary" :disabled="loading" text @click="subirRequisitos()"> Subir </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>
</template>

<script>
import InsRestDocus from '../Inscripcionrest-docs.vue'
import { cargarDocs } from '../documents/docs-up'

export default {
    components:{ InsRestDocus },
  data () {
    return {
      dialog: false,
      loading: false,
      xins_id: 0,
      msg: '',
    }
  },

  methods:{
    async openmodal(ins_id, prog){
        window.console.log('doscc',ins_id, prog);
        this.dialog = true;
        this.xins_id = ins_id;

        const institucionId = prog.universidad.id;
        const categoriaId = prog.postgrado.categoria.id;

        this.loading = true;
        setTimeout(async () => {
          this.cargarRequisitos(institucionId,categoriaId,ins_id);
        }, 300);
        
    },
    async cargarRequisitos(institucionId,categoriaId,ins_id){
        this.$refs.refDocus.setViewAsTable(true);
        await this.$refs.refDocus.cargarRequisitosDocs(institucionId,categoriaId,ins_id);
        this.loading = false; 
    },
    
    async subirRequisitos(){
        this.msg = '';
        let docus = this.$refs.refDocus.getRequisitos();
        window.console.log('docus::::::::::::::', docus);
        if( typeof(docus) == 'string' ) this.msg = docus;
        else{
            this.loading = true;
            let res = await cargarDocs(docus,this.xins_id);
            this.loading = false;
            window.console.log('>>>>', res);
            if(res && res.mensaje){
                this.msg = res.mensaje;
                let r = res.errores;

                for (const propiedad in r) {
                    this.msg += r[propiedad]
                }
            }
        }
    },
  }
}
</script>

